import { render } from "./DistributionTour.vue?vue&type=template&id=6167cda9&scoped=true&ts=true"
import script from "./DistributionTour.vue?vue&type=script&lang=ts"
export * from "./DistributionTour.vue?vue&type=script&lang=ts"

import "./DistributionTour.vue?vue&type=style&index=0&id=6167cda9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6167cda9"]])

export default __exports__